import React from 'react';
import { useApiAutocomplete } from '../../hooks/useApiAutocomplete';
import { application } from '../../services/application';
import { formatToTitleCase } from '../../utils/helpers';
import Autocomplete from '../common/Inputs/Autocomplete';

const getOptionLabel = (option) => (option && option.value ? `${option.value}` : '');

export const SBACertificationAutocomplete = (props) => {
  const { onChange, value, multi, labelKey = 'value', apiMethod, label, where = {}, formatLabelCB, ...rest } = props;

  const { options, loading, handleValueChange, filterOptions, handleInputChange } = useApiAutocomplete({
    labelKey,
    onChange: React.useCallback((val) => onChange && onChange(val), [onChange]),
    getOptionList: (params) => application.call(apiMethod, { ...params, where: { ...where } }),
  });

  const validateValueArray = () => {
    if (Array.isArray(value)) {
      return value;
    } else {
      return [];
    }
  };

  return (
    <Autocomplete
      options={options}
      label={label}
      labelKey={labelKey}
      loading={loading}
      value={validateValueArray()}
      filterOptions={filterOptions}
      onChange={handleValueChange}
      multiple={multi}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      freeSolo
      formatLabelCB={formatLabelCB || formatToTitleCase}
      onInputChange={handleInputChange}
      getOptionLabel={getOptionLabel}
      {...rest}
    />
  );
};
